import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  UpdateInstallableUrlMessage,
  UpdateInstallableUrlMessageVariables
} from './__generated__/UpdateInstallableUrlMessage'

const MUTATION = gql`
  mutation UpdateInstallableUrlMessage($input: UpdateInstallableUrlMessageInputV2!) {
    updateInstallableUrlMessageV2(input: $input) {
      ... on InstallableUrlMessageV2 {
        installableId
        name
        slug
        urlMessage
      }
      ... on InstallableErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateInstallableUrlMessage = () => {
  return useMutation<UpdateInstallableUrlMessage, UpdateInstallableUrlMessageVariables>(MUTATION)
}
